module.exports = __webpack_public_path__ + "a1f186e6afcf6a1c7284a9877b527561.png";